import Vue from "vue";
import moment from "moment";

export function displayLocalDateTime(string, format = "M/D/YY h:mm a") {
  return moment
    .utc(string)
    .local()
    .format(format);
}

export function displayRole(role) {
  if (role == "videographer") {
    return "Videographer";
  } else if (role == "media_purchaser") {
    return "Media Purchaser";
  } else if (role == "media_producer") {
    return "Media Producer";
  } else if (role == "administrator") {
    return "Administrator";
  } else if (role == "superadministrator") {
    return "Super Administrator";
  }
}

export function getRoleColor(role) {
  if (role == "videographer") {
    return "#4B5563";
  } else if (role == "media_purchaser") {
    return "#2563EB";
  } else if (role == "media_producer") {
    return "#059669";
  } else if (role == "administrator") {
    return "#D97706";
  } else if (role == "superadministrator") {
    return "#DC2626";
  }
}

export function timeAgo(date, includeAgo = false) {
  return moment.utc(date).fromNow(includeAgo);
}

export function videoDisplayProgress(value) {
  if (value == "trf_aws") {
    return "Transferring video to AWS for transcoding.";
  }
  if (value == "aws_trans") {
    return "AWS is currently transcoding this video.";
  }
  if (value == "yt_uploading") {
    return "Uploading video to YouTube.";
  }
  if (value == "yt_process") {
    return "YouTube is currently processing this video.";
  }
}

export function json(value) {
  return JSON.stringify(value);
}

export function timecode(value) {
  if (value !== null) {
    var seconds = Math.floor(value % 60).toString();
    var minutes = Math.floor(value / 60).toString();
    if (seconds.length === 1) {
      seconds = "0" + seconds;
    }
    return minutes + ":" + seconds;
  }
}

export function count(data) {
  if (data == null) {
    return 100;
  }
  return 100 - data.length;
}

export function displayFaaEventType(type) {
  if (type == "part107_initial") {
    return "Certificate Number";
  } else if (type == "part107_recurrent") {
    return "Certificate Number";
  } else if (type == "waiver") {
    return "Waiver Number";
  } else if (type == "laancreq") {
    return "Authorization Number";
  }
}

export function displaySaleStatus(data) {
  if (data == "pending") {
    return "Pending";
  } else if (data == "occurring") {
    return "Occurring";
  } else if (data == "complete") {
    return "Complete";
  }
}

export function abbrDesc(str, n = 300) {
  if (!str) return;
  return str.length > n ? str.substr(0, n - 1) + "..." : str;
}

export function initials(name, delimeter = " ") {
  if (name) {
    var array = name.split(delimeter);

    switch (array.length) {
      case 1:
        return array[0].charAt(0).toUpperCase();
      default:
        return (
          array[0].charAt(0).toUpperCase() +
          array[array.length - 1].charAt(0).toUpperCase()
        );
    }
  }
  return false;
}

export function displayPurchaseMethod(data) {
  if (data == "email") {
    return "Email";
  } else if (data == "cdn") {
    return "CDN";
  } else if (data == "manual") {
    return "Manual";
  }
  return "N/A";
}

export function secondsToReadable(value) {
  if (value !== null) {
    var seconds = Math.floor(value % 60).toString();
    var minutes = Math.floor(value / 60).toString();
    if (seconds.length === 1) {
      seconds = "0" + seconds;
    }
    return minutes + ":" + seconds;
  }
}

export function capitalize(s) {
  if (typeof s !== "string") return "";
  return s.charAt(0).toUpperCase() + s.slice(1);
}

export function numberWithCommas(x) {
  return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}

const filters = {
  displayLocalDateTime,
  displayRole,
  timeAgo,
  videoDisplayProgress,
  json,
  count,
  timecode,
  displayFaaEventType,
  displaySaleStatus,
  abbrDesc,
  initials,
  displayPurchaseMethod,
  secondsToReadable,
  capitalize,
  numberWithCommas,
  getRoleColor
};

Object.keys(filters).forEach(key => {
  Vue.filter(key, filters[key]);
});
